import { getCurrencySymbol } from "@features/helpers";

export const CHALLENGE_100K_V3_PAYWALL_STEP = 31;
export const CHALLENGE_100K_V3_DISCOUNT_PAYWALL_STEP = 32;

export const challenge100kV3Ids = [
    "71f5805b-6c90-4d3a-9e44-f2779ac93675",
    "909dc9e2-f5f5-45da-9875-6820faae522f",
    "79173e4a-effe-4f0b-aef1-a5ba9cd1a109"
];

export const challenge100kV3WithDiscountIds = [
    "5eacb8a5-9b02-4892-b243-23a25742156a",
    "d8fa8a16-7a26-4e6c-907d-23bfe1df925a",
    "c89842e3-c1df-4a72-b80c-3a993d7a1280"
];

export const getPaymentInfo100kV3 = (
    id: string,
    currency: string,
    priceBefore: number,
    priceAfter: number,
    buttonText: string
) => {
    const currencySymbol = getCurrencySymbol(currency);
    const formatPriceBefore = (priceBefore / 100).toFixed(2);
    const formatPriceAfter = (priceAfter / 100).toFixed(2);
    switch (id) {
        case "71f5805b-6c90-4d3a-9e44-f2779ac93675":
            return `By clicking ${buttonText}, you agree to pay ${currencySymbol}${formatPriceBefore} for the first 1-week period and authorize future charges, including automatic renewals at ${currencySymbol}${formatPriceAfter} every 4 weeks and additional purchases made through your account. You can cancel anytime in your account settings.`;
        case "909dc9e2-f5f5-45da-9875-6820faae522f":
            return `By clicking ${buttonText}, you agree to pay ${currencySymbol}${formatPriceBefore} for the first 4-week period and authorize future charges, including automatic renewals at ${currencySymbol}${formatPriceAfter} every 4 weeks and additional purchases made through your account. You can cancel anytime in your account settings.`;
        case "79173e4a-effe-4f0b-aef1-a5ba9cd1a109":
            return `By clicking ${buttonText}, you agree to pay ${currencySymbol}${formatPriceBefore} for the first 12-week period and authorize future charges, including automatic renewals at ${currencySymbol}${formatPriceAfter} every 12 weeks and additional purchases made through your account. You can cancel anytime in your account settings.`;
        case "5eacb8a5-9b02-4892-b243-23a25742156a":
            return `By clicking ${buttonText}, you agree to pay ${currencySymbol}${formatPriceBefore} for the first 1-week period and authorize future charges, including automatic renewals at ${currencySymbol}${formatPriceAfter} every 4 weeks and additional purchases made through your account. You can cancel anytime in your account settings.`;
        case "d8fa8a16-7a26-4e6c-907d-23bfe1df925a":
            return `By clicking ${buttonText}, you agree to pay ${currencySymbol}${formatPriceBefore} for the first 4-week period and authorize future charges, including automatic renewals at ${currencySymbol}${formatPriceAfter} every 4 weeks and additional purchases made through your account. You can cancel anytime in your account settings.`;
        case "c89842e3-c1df-4a72-b80c-3a993d7a1280":
            return `By clicking ${buttonText}, you agree to pay ${currencySymbol}${formatPriceBefore} for the first 12-week period and authorize future charges, including automatic renewals at ${currencySymbol}${formatPriceAfter} every 12 weeks and additional purchases made through your account. You can cancel anytime in your account settings.`;
    }
};

export const paywall100kV3Feedbacks = [
    {
        author: "@starter_jess",
        comment:
            "The content is super clear and beginner-friendly. It covers exactly what you need to get started with AI no fluff, just value. Perfect if you're just stepping into this world."
    },
    {
        author: "@echsavvy_omar",
        comment:
            "Tixu.ai provides a huge variety of tools and interactive lessons that break down complex AI concepts into something anyone can grasp. It’s a fresh and modern way to learn AI — props to the creators!"
    },
    {
        author: "@growwithzoe",
        comment:
            "Tixu.ai helped me level up faster than I expected. The personalized approach and easy-to-follow lessons made learning smooth and impactful. I now feel more confident and focused on my next career goals."
    }
];

export const paywall100kV3Benefits_old = [
    "Learn to create and sell with AI — from art to chatbots",
    "Discover AI tools that save time and make money",
    "Launch AI-powered projects in just 28 days"
];

export const paywall100kV3Benefits = [
    [
        "Learn to ",
        { text: "create", highlight: true },
        " and ",
        { text: "sell", highlight: true },
        " with AI — from art to chatbots"
    ],
    [
        "Discover AI tools that ",
        { text: "save time", highlight: true },
        " and ",
        { text: "make money", highlight: true }
    ],
    ["Launch AI-powered projects ", { text: "in just 28 days", highlight: true }]
];

export const screenShotes100kV3 = [
    "/images/onboarding/png/paywall/screen-1.png",
    "/images/onboarding/png/paywall/screen-2.png",
    "/images/onboarding/png/paywall/screen-3.png"
];
